"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const react_i18next_1 = require("react-i18next");
const TosCheckbox = ({ textColor, tosChecked, handleTosChecked, openTos, theme, text1, text2, linkColor, t, url }) => {
    const onTosClick = (event) => {
        if (openTos) {
            event.preventDefault();
            event.stopPropagation();
            openTos();
        }
    };
    const terms = () => {
        const color = textColor ? textColor : theme.palette.text.primary;
        return ((0, jsx_runtime_1.jsxs)(core_1.Typography, Object.assign({ variant: 'body2', align: 'center', style: { display: 'flex', alignItems: 'center', pointerEvents: 'auto', color } }, { children: [!!text1 ? text1 : `I accept the `, text2 ? ((0, jsx_runtime_1.jsx)(core_1.Link, Object.assign({ "aria-label": 'View terms and conditions.', onClick: url ? undefined : onTosClick, className: 'linkButton', style: { marginLeft: theme.spacing(), pointerEvents: 'auto', color: linkColor }, component: 'a', href: url }, { children: t(text2) }))) : null] })));
    };
    return ((0, jsx_runtime_1.jsx)(core_1.FormControlLabel, { style: { pointerEvents: 'none' }, control: (0, jsx_runtime_1.jsx)(core_1.Checkbox, { checked: tosChecked, onChange: handleTosChecked, value: "checked", color: "primary", style: { pointerEvents: 'auto' } }), label: terms() }));
};
exports.default = (0, core_1.withTheme)((0, react_i18next_1.withTranslation)()(TosCheckbox));
//# sourceMappingURL=TosCheckbox.js.map